<template>
  <div class="purchase-boxs">
    <div
      :class="[
        'purchase-server',
        { 'purchase-server-active': item.isChecked },
        { 'purchase-server-disabled': item.disabled }
      ]"
      :key="item.key"
      v-for="(item, idx) in list"
      @click="onClick(item, idx)"
    >
      <p class="purchase-server-number">{{ formatNumber(item.label) }}</p>
      <p class="purchase-server-unit">{{ item.txt }}</p>
      <ux-checkbox class="purchase-server-checkbox" :value="item.isChecked"></ux-checkbox>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PurchaseBoxs',
  props: {
    list: {
      type: Array,
      default: () => {
        return [];
      }
    }
  },
  data() {
    return {};
  },
  methods: {
    /**
     * 选择服务
     */
    onClick(item, idx) {
      if (item.disabled) return;
      this.$emit('click', item, idx);
    },
    /**
     * 每三位数加逗号
     */
    formatNumber(num) {
      return this.$formatNumber(num);
    }
  }
};
</script>

<style lang="scss" scoped>
.purchase-boxs {
  font-size: 0;

  .purchase-server {
    box-sizing: border-box;
    position: relative;
    display: inline-flex;
    justify-content: center;
    flex-direction: column;
    vertical-align: top;
    width: 104px;
    height: 80px;
    padding: 0 16px;
    background: $color-bg-disable;
    border-radius: 8px;
    border: 1px solid $color-disable;
    overflow: hidden;
    margin-right: 20px;
    margin-bottom: 20px;
    cursor: pointer;

    &:hover {
      border: 1px solid $color-text-disable;
      background: #fff;
    }

    .purchase-server-number {
      font-size: 14px;
      font-weight: 900;
      color: $color-title;
      line-height: 20px;
    }

    .purchase-server-unit {
      font-size: 12px;
      font-weight: 400;
      color: $color-text;
      line-height: 16px;
      text-overflow: -o-ellipsis-lastline;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      line-clamp: 2;
      -webkit-box-orient: vertical;
      margin-top: 4px;
    }

    ::v-deep .purchase-server-checkbox {
      pointer-events: none;
      position: absolute;
      bottom: 0;
      right: 0;
      font-size: 0;
      z-index: 2;

      .el-checkbox {
        font-size: 0;
      }

      .el-checkbox__label {
        display: none;
      }

      .el-checkbox__inner {
        transition: none;
        border: 1px solid transparent;
        border-radius: 8px 0px 0px 0px;
        background-color: transparent;

        &::after {
          transition: none;
        }
      }

      .is-checked {
        .el-checkbox__inner {
          background-color: $color-primary;
        }
      }
    }

    &.purchase-server-active {
      border: 2px solid $color-primary;
      padding: 0 15px;
      background: #fff;

      .purchase-server-number {
        color: $color-primary;
      }
    }

    &.purchase-server-disabled {
      border: 1px solid $color-bg-disable;
      background: $color-bg-disable;
      cursor: no-drop;

      .purchase-server-number {
        color: $color-text-disable;
      }

      .purchase-server-unit {
        color: $color-text-disable;
      }
    }
  }
}
</style>
